const my_profile = {
  viewMyClubSeacretProfile: "Mein ClubSeacret-Profil anzeigen", // translated
  verifiedEmail: "Verifizierte E-Mail", // translated
  unverifiedEmail: "unverifizierte Email", // translated
  viewMoreDetails: "Weitere Details anzeigen", // translated
  createdFrom: "Erstellt ab", // translated
  createdTo: "Erstellt bis", // translated
  selectStatus: "Status auswählen...", // translated
  searchByTitle: "Nach Titel suchen...", // translated
  pushNotifications: "Push-Benachrichtigungen",
  pushNotificationsDescription: "Browser-Benachrichtigungen für wichtige Updates und Ereignisse erhalten",
  pushNotificationsNotSupported: "Push-Benachrichtigungen werden in diesem Browser nicht unterstützt",
  pushNotificationsDeniedMessage: "Die Benachrichtigungsberechtigung wurde verweigert. Bitte aktivieren Sie Benachrichtigungen in Ihren Browsereinstellungen, um Push-Benachrichtigungen zu erhalten.",
  pushNotificationsEnabled: "Push-Benachrichtigungen erfolgreich aktiviert",
  pushNotificationsDisabled: "Push-Benachrichtigungen erfolgreich deaktiviert",
  userInformationMissing: "Benutzerinformationen fehlen",
  failedToUpdatePushNotifications: "Fehler beim Aktualisieren der Push-Benachrichtigungseinstellungen",
  notificationPermissionDenied: "Die Benachrichtigungsberechtigung wurde verweigert. Bitte aktivieren Sie sie in Ihren Browsereinstellungen.",
  notificationPermissionRequired: "Die Benachrichtigungsberechtigung ist erforderlich, um Push-Benachrichtigungen zu aktivieren",
  notSupported: "Nicht unterstützt",
  permissionDenied: "Berechtigung verweigert",
  permissionNotRequested: "Berechtigung nicht angefordert",
  enabled: "Aktiviert",
  disabled: "Deaktiviert",
};

export default my_profile;
